import React, { useState, useEffect, useCallback } from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { Col, Container, Row } from 'react-bootstrap';
import HomeIcon from '../../../../public/assets/img/icon-home.svg';
import { useNavigate } from 'react-router-dom';
import { toggleLeftPanelSelector } from '../../../redux/saga/checkmateAuthorizationSelector';
import { useDispatch, useSelector } from 'react-redux';
import { apiLoadingSaga, organizationSelectedSaga, storeListSaga } from '../../../redux/saga/merchantServiceSelectors';
import { merchantGetBrandList, merchantGetOrganization, setIntegrationAccessToken, setReadAccessToken, updateLoadingStatus } from '../../../redux/actions/merchantAction';
import OtterBrands from '../../../otter/otter.brands';
import OtterStores from '../../../otter/otter.stores';
import { CircularProgressLoader } from '../../../shared/components/Loaders';
import { initializaMerchantState } from '../../../redux/actions/amazonWebServicesAction';
import { delete_cookie, getCookie, getTargetDate } from '../../../shared/utils/format.helpers';
import { loginResponseSaga, refreshLogicSaga } from '../../../redux/saga/loginServiceSelector';
import { restoreUserSession } from '../../../redux/actions/loginServiceAction';
import { useCookies } from 'react-cookie';
import { RENDERING_STORE_LIST } from '../../../constants/merchantsConstants';

const DashboardBrand = () => {
	const dispatch = useDispatch();
  	const navigate = useNavigate();
	const [cookies, setCookie, removeCookie] = useCookies(['_tMerV', '_cMerV']);
	const [leftPanelOpen, setLeftPanelOpen] = useState(true);
	const toggleLeftPanel = useSelector(toggleLeftPanelSelector);
	const [selectedIndex, setSelectedIndex] = useState(0);
	const [storeName, setStoreName] = useState('');
	const [content, setContent] = useState(null);
	const initialRoute = 'otter';
	const organization = useSelector(organizationSelectedSaga);
	const apiLoading = useSelector(apiLoadingSaga);
	const storeListData = useSelector(storeListSaga);
  	const loginResponseData = useSelector(loginResponseSaga);
  	const refreshLogic = useSelector(refreshLogicSaga);

	useEffect(() => {
		if (sessionStorage.getItem('access_token_otter')) {
			dispatch(setReadAccessToken(sessionStorage.getItem('access_token_otter')));
		}
		if (sessionStorage.getItem('integration_token_otter')) {
			dispatch(setIntegrationAccessToken(sessionStorage.getItem('integration_token_otter')));
		}

		if (getCookie('_cMerV') && getCookie('_tMerV') && loginResponseData === null) {
			if (JSON.parse(JSON.stringify(cookies['_tMerV']))?.idToken) {
				dispatch(restoreUserSession(cookies['_tMerV'], cookies['_cMerV'], cookies['_rMerV']));
			} else {
				// logoutHandle();
				// navigate('/otter');
			}
		}
		dispatch(merchantGetOrganization({}));
	}, []);

	useEffect(() => {
		if (loginResponseData) {
			if (loginResponseData && !loginResponseData?.msg) {
				let targetDate;
				let tMerObj;
				let cMerObj;
				let rMerObj;

				if (loginResponseData?.idToken && !refreshLogic) {
					targetDate = getTargetDate(loginResponseData?.tokenTime);
					tMerObj = {
						idToken: loginResponseData.idToken,
						tokenTime: loginResponseData.tokenTime,
					};
					document.cookie = `_tMerV=${JSON.stringify(tMerObj)};expires=${targetDate};path=/;secure`;
					rMerObj = {
						refreshToken: loginResponseData.refreshToken,
					};
					document.cookie = `_rMerV=${JSON.stringify(rMerObj)};expires=${targetDate};path=/;secure`;
					cMerObj = {
						accessToken: loginResponseData.accessToken,
						expiresIn: loginResponseData.expiresIn,
						aggregator: loginResponseData.aggregator,
						merchantId: loginResponseData.merchantId,
						isAdmin: loginResponseData.isAdmin,
						userName: loginResponseData.userName,
						emailId: loginResponseData.emailId,
					};
					document.cookie = `_cMerV=${JSON.stringify(cMerObj)};expires=${targetDate};path=/;secure`;
				}
			}
		}
	}, [loginResponseData]);

	useEffect(
		useCallback(() => {
		if (organization && organization?.name) {
			setStoreName(organization.name);
			dispatch(merchantGetBrandList({}));
			setContent(<OtterBrands />);
		} else if (organization && organization?.msg) {
			setContent(<div style={{paddingTop: '20%'}}>Unknown Error. Please try again later</div>);
			if(organization?.data?.status == 401) {
				setContent(<div style={{paddingTop: '20%'}}>Authorization Issue. Please try again later</div>);
			}
		}
		}),
		[organization]
	);

	useEffect(
		useCallback(() => {
		if (storeListData && storeListData?.items) {
					dispatch(updateLoadingStatus({statustext: RENDERING_STORE_LIST, status: true}))
			setContent(<OtterStores setContent={setContent} />);
		}
		}),
		[storeListData]
	);

	useEffect(() => {
		setLeftPanelOpen(toggleLeftPanel);
	}, [toggleLeftPanel]);

	const logoutHandle = () => {
		delete_cookie('_tMerV', '/', '');
		sessionStorage.removeItem('access_token_otter');
		sessionStorage.removeItem('integration_token_otter');
		dispatch(initializaMerchantState({ type: 'RESET_STATE' }));
		sessionStorage.removeItem('userName');
		sessionStorage.removeItem('userEmail');
		sessionStorage.removeItem('endDate');
		sessionStorage.removeItem('startDate');
		sessionStorage.removeItem('selectedOption');
		sessionStorage.removeItem('isAdmin');
		sessionStorage.removeItem('merchantId');
		sessionStorage.removeItem('merchantName');
		delete_cookie('_cMerV', '/', '');
		delete_cookie('_rMerV', '/', '');
		navigate('/' + initialRoute);
	};

	const handleListItemClick = useCallback((index) => {
		dispatch(merchantGetBrandList(''));
		setContent(<OtterBrands />);
	});

	return (
		<Container fluid className='d-flex flex-column ' data-testid='dashboard-id'>
			<Row>
				{leftPanelOpen ? (
				<Col className='brand--col' xs={3}>
					<div className='brand--box'>
					<div className='brand--box1'>
						<h4 className='brand--box1--text'>{storeName.replace('[DO NOT CHANGE] ', '')}</h4>
					</div>
					</div>
					<List
						sx={{
							height: 'calc(100% - 200px)',
							'& .Mui-selected, && .Mui-selected:hover': {
							color: '#000000',
							backgroundColor: 'rgb(254 255 255) !important',
							borderRadius: '5px',
							'& .MuiListItemIcon-root, && .Mui-selected:hover': {
								color: '#FF6C00',
							},
							},
							'& .MuiListItemIcon-root': {
							minWidth: '40px',
							},
						}}
					>
					{['Brands'].map((text, index) => (
						<ListItem
							key={text}
							disablePadding
							sx={{
								'&:hover': {
								backgroundColor: '#FFFFFF',
								color: '#000000',
								borderRadius: '5px',
								'& .MuiSvgIcon-root': {
									color: '#FF6C00',
								},
								},
							}}
						>
							<ListItemButton selected={selectedIndex === index} onClick={() => handleListItemClick(index)}>
								<ListItemIcon>{index === 0 ? <img src={HomeIcon} /> : null}</ListItemIcon>
								<ListItemText primaryTypographyProps={{ className: 'brand--box__label' }} primary={text} data-testid='menuitem'/>
							</ListItemButton>
						</ListItem>
					))}
					</List>
					<List
						sx={{
							'& .Mui-selected, && .Mui-selected:hover': {
							color: '#000000',
							backgroundColor: 'rgb(254 255 255) !important',
							borderRadius: '5px',
							'& .MuiListItemIcon-root, && .Mui-selected:hover': {
								color: '#FF6C00',
							},
							},
							'& .MuiSvgIcon-root': {
							minWidth: '25px',
							marginRight: '15px',
							marginLeft: '0px',
							},
						}}
					>
						<ListItem
							disablePadding
							sx={{
							'&:hover': {
								backgroundColor: '#FFFFFF',
								color: '#000000',
								borderRadius: '5px',
								'& .MuiSvgIcon-root': {
								color: '#FF6C00',
								},
							},
							}}
						>
							<ListItemButton onClick={() => logoutHandle()}>
								<LogoutOutlinedIcon />
								<ListItemText primaryTypographyProps={{ className: 'brand--box__label' }} primary='Log Out' />
							</ListItemButton>
						</ListItem>
					</List>
				</Col>
				) : null}
				<Col xs={leftPanelOpen ? 9 : 12} style={{ padding: '0' }}>
				{content}
				</Col>
			</Row>
			{apiLoading === true ? (
				<div className='loader-style'>
					<CircularProgressLoader />
				</div>
			) : null}
		</Container>
	);
};

export default React.memo(DashboardBrand);
